import { FormInputProps } from "../../types/formInputProps"
//import FormInputDropdown from "./form-component/FormInputDropDown"
import FormInputDropMultiSelect from "./form-component/FormInputDropMultiSelect"

interface ZodiakProps extends Omit<FormInputProps, 'label'> {
    labelString: string;
    options: any[];
}

const ZodiakDropDown = ({ name, labelString, control, setValue, options }: ZodiakProps) => {
    return (
        <>
            <FormInputDropMultiSelect
                name={name}
                control={control}
                setValue={setValue}
                label={labelString}
                options={options}
            />
        </>
    )
} // Выберите знак зодиака



export default ZodiakDropDown

